import * as getters from "../../baseQuestion/text/store/getters";
import * as mutations from "../../baseQuestion/text/store/mutations";
import * as actions from "../../baseQuestion/text/store/actions";
import { state as base_state } from "../../baseQuestion/text/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_clubs"
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
